export default {
  LOAD_CLUB (state, payload) {
    state.clubObject = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/club/vuex/mutations.js